import { getCommunityProfilePageUrl } from 'lib/community';
import Link from 'next/link';
import {
  CommentAuthor as CommunityCommentAuthor,
  authorName,
} from 'types/comment';
import styles from './CommentAuthor.module.css';

type Props = {
  author: CommunityCommentAuthor;
};

export default function CommentAuthor(props: Props) {
  return (
    <div className={styles.CommentAuthor}>
      <Link href={getCommunityProfilePageUrl(props.author.username)}>
        {authorName(props.author)}
      </Link>
    </div>
  );
}
